export default {
  name: 'NiotaClassicCommonTablePageSelector',
  props: {
    page: {
      type: Number,
      required: true,
      default: 1
    },
    tableMaxItems: {
      type: Number,
      required: true,
      default: undefined
    },
    tableItemsPerPage: {
      type: Number,
      required: true,
      default: undefined
    },
    titleTxt: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      currentPage: this.page
    };
  },
  computed: {
    maxPages() {
      const maxItems = this.tableMaxItems || 0;
      return Math.ceil(maxItems / this.tableItemsPerPage);
    },
    labelInfo() {
      return `${this.page} / ${this.maxPages}`;
    }
  },
  watch: {
    page: function (valNew) {
      this.currentPage = valNew;
    }
  },
  methods: {
    setTablePageOnInput(num) {
      const numParsed = parseInt(num, 10) || 1;
      const currentPage = Math.min(Math.max(numParsed, 1), this.maxPages);
      this.$emit('page-change', currentPage);
    }
  }
};